export const plansDataAdmin = [
    {
        id: 1,
        name: 'Tradicional',
        supply: '50%',
        brokersInfo: 'por comisión de corretaje',
        characteristics: [
          'Estudio de mercado.',
          'Evaluación Comercial quincenal.',
          'Fotos profesionales',
          'Publicación en 30 portales inmobiliarios.',
          'Publicación preferencial',
          'Ofertas formales con garantía',
          'Asesoría Legal.',
          'Firma programada en Notaria (cero filas)',
          'Firma electrónica avanzada.',
          'Acta de entrega con respaldo fotográfico',
        ],
      },
      {
        id: 2,
        name: 'Comisión Inteligente',
        supply: '25%',
        brokersInfo: 'Por comisión de corretaje',
        characteristics: [
          '0% en segunda colocación (la propiedad debe ser exclusiva de Aulen)',
          '5% del valor de arriendo por administración mensual.',
          'Estudio de mercado',
          'Fotos profesionales',
          'Publicación en 30 portales inmobiliarios.',
          'Publicación preferencial',
          'Ofertas formales con garantía',
          'Asesoría legal',
          'Firma programada en Notaria (cero filas)',
          'Acta de entrega con respaldo fotográfico',
          'Verificación de pagos de servicios y GGCC.',
          'Cobro arriendo',
          'Gestión de reparaciones y  manutención',
          'Servicio legal total: ',
          'Desalojar al arrendatario',
          'Daños de terceros'
        ],
      },
      {
        id: 3,
        name: 'Administración con garantía',
        supply: '50%',
        brokersInfo: 'por comisión de corretaje',
        characteristics: [
          '6 meses de pago de arriendo, en caso de no pago.',
          '7,5% del valor de arriendo por administración mensual.',
          'Estudio de mercado',
          'Fotos profesionales',
          'Publicación en 30 portales inmobiliarios',
          'Ofertas formales con garantía',
          'Asesoría legal',
          'Firma programada en Notaria(cero filas).',
          'Firma electrónica avanzada.',
          'Acta de entrega con respaldo fotográfico',
          'Verificación de pagos de servicios y GGCC.',
          'Cobro arriendo',
          'Gestión de reparaciones y  manutención',
          'Servicio legal total: ',
          'Desalojar al arrendatario',
          'Daños de terceros'
        ],
      },
  ];
  